export default "__VITE_ASSET__BdrT29aU__"